const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const { requestAccountInterveners } = require('actions/getAccountInterveners');
const { fetchPregantedCreditDetails } = require('actions/credits/pregrantedCredits');

// @components
const CreditGeneralData = require('components/credits/creditGeneralData/creditGeneralData');

class CreditPregrantedView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { match: { params: { creditId } }, fetchPregantedCreditDetails } = this.props;
        this.getCreditInformation();
        fetchPregantedCreditDetails(creditId);
    }

    getCreditInformation() {
        const { match: { params: { creditId } }, requestAccountInterveners } = this.props;
        requestAccountInterveners(creditId);
    }

    render() {
        const { match: { params: { creditId } }, immPregrantedCredits, immAccounts, location } = this.props;
        let content = <LoadingSection />;

        if (!immPregrantedCredits.get('byOrder').isEmpty()) {
            const immCredit = immPregrantedCredits.getIn(['byId', creditId]);
            const immInterveners = immAccounts.getIn(['byId', creditId, 'interveners']);

            if (immCredit) {
                content = (
                    <CreditGeneralData immCredit={immCredit}
                        immInterveners={immInterveners}
                        getInformation={this.getCreditInformation}
                        path={location.pathname}
                    />
                );
            }
        }

        return content;
    }
}

CreditPregrantedView.propTypes = {
    fetchPregantedCreditDetails: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immPregrantedCredits: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

module.exports.CreditPregrantedView = connect(
    state => ({
        immAccounts: state.accounts,
        immPregrantedCredits: state.creditsPregranted
    }),
    {
        requestAccountInterveners,
        fetchPregantedCreditDetails
    }
)(withRouter(CreditPregrantedView));
